module.exports = ['$scope', '$rootScope', 'Map', 'Stories', '$modal', '$compile', 'PICTURE_PATH', function ($scope, $rootScope, Map, Stories, $modal, $compile, PICTURE_PATH) {
    var body = angular.element(document).find('body')[0];
    body.style.overflow = "hidden"
    $scope.markers = Map.getMapMarkers();
    $scope.Stories = Stories;
   

    $.getScript('https://maps.google.com/maps/api/js?key=AIzaSyD0wM2gKwK7fU7j-Eb0qGORb0oWytIJSko&libraries=places', function () {
       

        var map = new google.maps.Map(document.getElementById('map'), {
            center: { lat: 31.9771, lng: 34.7897 },
            zoom: 9
        });

        var infowindow = new google.maps.InfoWindow({ disableAutoPan: false, pixelOffset: { 'width': -104, 'height': 244 } });

        var allMarkers = [],
            markerImage = {
                url: require("../../img/headerIcons/mapMarker.svg"),
                scaledSize: new google.maps.Size(42, 34),
            };

        angular.forEach($scope.markers, function (mark) {
            var marker = new google.maps.Marker({
                position: { lat: parseFloat(mark.field_google_map_lat), lng: parseFloat(mark.field_google_map_lon) },
                map: map,
                icon: markerImage,
                optimized: false,
                //title: mark.title
            });

            marker.setMap(map);
            marker.latitude = mark.field_google_map_lat;
            marker.longitude = mark.field_google_map_lon;
            marker.tooltip = mark.title;

            var infoElement = '<div class="marker">' +
                    '<div class="closeBtn"><div class="close" ng-click="closeMarker(marker)"></div></div><img class="image" src="' + PICTURE_PATH + mark.filename + '"/>' +
                    '<div class="titleInfo" ng-click="openStoryAdults(' + mark.nid + ')" +>' + '<div class="arrowYellow"></div><div class="infoTitleText">' + mark.title + '</div></div>';
            var infoCompiled = $compile(infoElement)($scope);
            var tooltipElement = '<div class="tooltipMarker">' + mark.title + '</div>';

            google.maps.event.addListener(marker, 'click', function () {

                infowindow.setContent(infoCompiled[0]);
                infowindow.open(map, this);

                //override default css
                var iwOuter = document.getElementsByClassName('gm-style-iw')[0];
                var iwOuters = document.getElementsByClassName('gm-style-iw');
                angular.forEach(iwOuters, function (iwOuter) {
                    console.log(iwOuter)
                    iwOuter.style["overflow"] = 'visible';
                    //iwOuter.parentNode.parentNode.style["left"] = '-104px';
                    //iwOuter.parentNode.parentNode.style["top"] = '244px';

                    var iwBackground = iwOuter.previousSibling
                    iwBackground.childNodes[0].style["display"] = 'none';
                    iwBackground.childNodes[1].style["display"] = 'none';
                    iwBackground.childNodes[2].style["display"] = 'none';
                    iwBackground.childNodes[3].style["display"] = 'none';
                    var iwCloseBtn = iwOuter.nextSibling;
                    iwCloseBtn.style["display"] = 'none';

                    iwCloseBtn.onmouseout = function () {
                        iwCloseBtn.style["opacity"] = '1';
                    };
                })

            });

            var mouse = {
                x: 0,
                y: 0
            };

            document.addEventListener('mousemove', function (e) {
                mouse.x = e.clientX || e.pageX;
                mouse.y = e.clientY || e.pageY
            }, false);

            google.maps.event.addListener(marker, 'mouseover', function (event) {
                var parent = $('.theMap');
                parent.append("<div id=\"tt\"></div>");
                $("#tt").css("left", mouse.x + "px").css("top", (mouse.y + 35) + "px").attr("title", marker.tooltip).tooltip('show');
            });

            google.maps.event.addListener(marker, 'mouseout', function (event) {
                $("#tt").tooltip('hide');
                $("#tt").remove();
            });

            allMarkers.push(marker);
        })

        //add
        // Try HTML5 geolocation.
        var myLocation = new google.maps.InfoWindow({ map: map, disableAutoPan: false });
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                var pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };


                var positionImage = {
                    url: require("../../img/headerIcons/positionMarker.svg"),
                    scaledSize: new google.maps.Size(42, 34),
                };

                var markerPosition = new google.maps.Marker({
                    position: pos,
                    map: map,
                    icon: positionImage,
                    optimized: false,
                });

                markerPosition.setMap(map);
                myLocation.setPosition(pos);
                myLocation.setContent('<div class="myPosition">את/ה נמצא/ת כאן</div>');
                //map.setCenter(pos);

                //override default css
                var iwOuter = document.getElementsByClassName('gm-style-iw')[0];
                console.log(iwOuter)
                iwOuter.style["overflow"] = 'visible';
                var iwBackground = iwOuter.previousSibling
                iwBackground.childNodes[0].style["display"] = 'none';
                iwBackground.childNodes[1].style["display"] = 'none';
                iwBackground.childNodes[2].style["display"] = 'none';
                iwBackground.childNodes[3].style["display"] = 'none';
                var iwCloseBtn = iwOuter.nextSibling;
                iwCloseBtn.style["display"] = 'none';
            }, function () {
                //handleLocationError(true, myLocation, map.getCenter());
            });
        } else {
            // Browser doesn't support Geolocation
            //handleLocationError(false, myLocation, map.getCenter());
        }

        function handleLocationError(browserHasGeolocation, myLocation, pos) {
            myLocation.setPosition(pos);
            myLocation.setContent(browserHasGeolocation ?
                                  'Error: The Geolocation service failed.' :
                                  'Error: Your browser doesn\'t support geolocation.');
        }

        //end add

        $scope.closeMarker = function (marker) {
            infowindow.close(map, marker);
        }

         $scope.$on('resultSelected', function (event, args) {
            var mark = args.any.originalObject
            var openmarker = findMarker(args.any.originalObject)
            if (openmarker) {
                map.setCenter(openmarker.getPosition());
                google.maps.event.trigger(openmarker, 'click');
            }

        });


         function findMarker(obj) {
             console.log(parseFloat(obj.field_google_map_lat))
             for (var i = 0; i < allMarkers.length; i++) {
                 if ((allMarkers[i].latitude == obj.field_google_map_lat) && (allMarkers[i].longitude == obj.field_google_map_lon)) {
                     console.log(allMarkers[i])
                     console.log(obj)
                     return allMarkers[i];
                     break;
                 }
             }
         }
    });


   
}];


//////////////////
// WEBPACK FOOTER
// ./public/js/controllers/mapCtl.js
// module id = 97
// module chunks = 0